import { CONSORS_ADD_NOTE_FAILURE_REASONS, CONSORS_ADD_NOTE_STATUSES, CONSORS_NOTE_SOURCES } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../../utils/schema.utils';

export const schemaConsorsNote = z.object({
    data: z.object({
        content: z.string().min(1).max(500),
        creationDate: z.string().nullish(),
        employeeName: z.string().max(50).nullish(),
        id: schemaId,
    }),
    errorMessage: z.string().nullish(),
    failureReason: z.nativeEnum(CONSORS_ADD_NOTE_FAILURE_REASONS).nullish(),
    source: z.nativeEnum(CONSORS_NOTE_SOURCES),
    status: z.nativeEnum(CONSORS_ADD_NOTE_STATUSES),
});

export type SchemaConsorsNote = z.infer<typeof schemaConsorsNote>;
